import { gql } from '@apollo/client';

const GET_CURRENT_USER = gql`
  query {
    getCurrentUser {
      id
      company
      email
      firstname
      lastname
      jobTitle
      tel
      mobile
    }
  }
`;

const GET_USER = gql`
  query getUser($id: String!) {
    user: getUser(id: $id) {
      id
      company
      email
      firstname
      lastname
      jobTitle
      tel
      mobile
    }
  }
`;

const GET_COUNTRIES = gql`
  query getCountries {
    countries: getCountries(sort: [{ property: "name", direction: "asc" }]) {
      id
      name
      code
    }
  }
`;

const GET_COUNTIES_BY_COUNTRY_ID = gql`
  query getCounties($countryId: String!) {
    counties: getCounties(
      where: { countryId: $countryId }
      sort: [{ property: "name", direction: "asc" }]
    ) {
      id
      code
      name
      countryId
      country {
        code
        name
      }
    }
  }
`;

const GET_PAGE_WITH_BRANDS = gql`
  query getPublishedPage($id: String!) {
    pageData: getPublishedPage(id: $id) {
      __typename
      id
      name
      brandIds
    }
  }
`;

const getPageQuery = entity => {
  const capitalized = entity.charAt(0).toUpperCase() + entity.slice(1);
  return gql`
  query getRecordData($id: String!) {
    pageData: getPublished${capitalized}(id: $id) {
      __typename
      id
      name
      brandIds
      brands {
        id
        name
      }
    }
  }
`;
};

const GET_SEARCH_PUBLISHED_CONTENT = gql`
  query searchPublishedContent(
    $rawQueryStringified: String!
    $offset: Int
    $limit: Int
    $sort: String
  ) {
    searchPublishedContent(
      rawQueryStringified: $rawQueryStringified
      offset: $offset
      limit: $limit
      sort: $sort
    ) {
      rawResults
    }
  }
`;

const GET_PRODUCT_TYPES = gql`
  query getProductTypes(
    $where: JSON!
    $offset: Int
    $limit: Int
    $sort: [GetProductTypesSortItem]
  ) {
    productTypes: getProductTypes(where: $where, offset: $offset, limit: $limit, sort: $sort) {
      id
      name
      url
      image {
        id
        url
        name
      }
    }
  }
`;

const GET_BRANDS = gql`
  query getBrands($where: JSON!, $offset: Int, $limit: Int, $sort: [GetBrandsSortItem]) {
    brands: getBrands(where: $where, offset: $offset, limit: $limit, sort: $sort) {
      id
      name
      url
      image {
        id
        url
        name
      }
    }
  }
`;

export {
  GET_USER,
  GET_COUNTRIES,
  GET_COUNTIES_BY_COUNTRY_ID,
  GET_PAGE_WITH_BRANDS,
  GET_PRODUCT_TYPES,
  GET_SEARCH_PUBLISHED_CONTENT,
  GET_BRANDS,
  GET_CURRENT_USER,
  getPageQuery
};
